import {
    AnimationBaseController,
    GameApiBase
} from "@denishussar/html5-game-engine";
import {Inject} from "@denishussar/html5-game-engine";
import {IAnimationControllerConfiguration} from "@denishussar/html5-game-engine";
import {GameModel} from "../../../Models/GameModel";
import {AnimationContents} from "../../AnimationContents";
import {GameLogic} from "../../../Logic/GameLogic";

import {ButtonController, IButtonControllerOptions} from "../../Common/ButtonController";
import {OpponentDifficultyController} from "./OpponentDifficultyController";
import {MapSizeController} from "./MapSizeController";
import {HandChoiceController} from "./HandChoiceController";
import {CharSelectController} from "./CharSelectController";
import {LocalizationContents} from "../../../LocalizationContents";

export interface IIntroScreenControllerOptions
{
}

export class CharChoiceScreenController extends AnimationBaseController {
    $model: GameModel;

    public constructor(@Inject private _options:IIntroScreenControllerOptions,
                       @Inject private _gameLogic: GameLogic,
                       @Inject private _arenaApi: GameApiBase) {
        super("CharChoiceScreenController");
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return <IAnimationControllerConfiguration>{
            animationContent: AnimationContents.CHAR_CHOICE_SCREEN_JSON,
            libraryName: "char_choice_screen",
            childControllers: {
                PlayButton: {
                    instanceName: "btn_play",
                    view: ButtonController,
                    model: this.$model,
                    options: <IButtonControllerOptions>{
                        onClick: () =>{
                            this._gameLogic.showMiniGame();
                        },
                        localKey: LocalizationContents.keys.menu_play
                    }
                },
                CloseButton: {
                    instanceName: "button_close_char_choice",
                    view: ButtonController,
                    model: this.$model,
                    options: <IButtonControllerOptions>{
                        onClick: () =>{

                            this._gameLogic.hidenModal();
                            this._gameLogic.showMainMenu();
                        }
                    }
                },
                OpponentDifficulty:{
                    animationContent: AnimationContents.CHAR_CHOICE_SCREEN_JSON,
                    libraryName: "opponent_difficulty",
                    view: OpponentDifficultyController,
                    model: this.$model,
                    x:330,
                    y:-100
                },
                MapSize:{
                    animationContent: AnimationContents.CHAR_CHOICE_SCREEN_JSON,
                    libraryName: "map_size",
                    view: MapSizeController,
                    model: this.$model,
                    x:300,
                    y:260
                },
                HandChoice:{
                    animationContent: AnimationContents.CHAR_CHOICE_SCREEN_JSON,
                    libraryName: "hand_choice",
                    view: HandChoiceController,
                    model: this.$model,
                    x:-470,
                    y:370
                },
                CharSelect:{
                    animationContent: AnimationContents.CHAR_CHOICE_SCREEN_JSON,
                    libraryName: "game_set",
                    view: CharSelectController,
                    model: this.$model,
                    x:-350,
                    y:-100
                },
            },
            modelWatch: {
                
            }
        };
    }



    protected onInitialize(): void {
        this.setTextByQuery("config_difficulty", LocalizationContents.config_difficulty);
        this.setTextByQuery("config_field", LocalizationContents.config_field);
        this.setTextByQuery("config_hand", LocalizationContents.config_hand);
        this.setTextByQuery("config_character", LocalizationContents.config_character);
        this.display.scale.set(.65);
    }




    protected onLandscape(): void {
    }

    protected onPortrait(): void {
    }

    protected onUpdate(frameRate: number): void {
    }

}

